export class CONSTANTS {

    // Language Constants
    static readonly LANGUAGE_EN_US = 'en-US';
    static readonly LANGUAGE_EN_CA = 'en-CA';
    static readonly LANGUAGE_FR_CA = 'fr-CA';

    // Split View Constants
    static readonly SPLIT_WORKSPACE_WIDTH = 60;
    static readonly SPLIT_LIBRARY_WIDTH = 20;
    static readonly SPLIT_ESTIMATE_WIDTH = 80;
    static readonly SPLIT_REPORT_WIDTH = 80;
    static readonly SPLIT_NO_WIDTH = 0;

    //Preferences constants
    static readonly DECIMAL_PRECISION_MIN_VALUE = 0;
    static readonly DECIMAL_PRECISION_MAX_VALUE = 2;
    static readonly ESTIMATE_DISPLAY_MIN_VALUE = 4;
    static readonly ESTIMATE_DISPLAY_MAX_VALUE = 12;
    static readonly FAVOURITE_ESTIMATE_DISPLAY_MIN_VALUE = 1;
    static readonly FAVOURITE_ESTIMATE_DISPLAY_MAX_VALUE = 4;
    static readonly SIEMENS_EMAIL_DOMAIN = '@siemens.com';
    static readonly TWENTY = 20;
    static readonly ONE_MILLION = 1000000;
    static readonly ZERO_POINT_NINE_NINE = 0.99;
    static readonly ZERO_POINT_ONE = 0.1;

    //Collaboration Constants
    static readonly REQUEST_ACCESS = 'requestAccess';
    static readonly PUBLISHED = 'published';
    static readonly DISCARDED = 'discarded';
    static readonly PUBLISH_FAILED = 'publishFailed';
    static readonly DISCARD_FAILED = 'discardFailed';
    static readonly COLLABORATION_POPUP_WIDTH = '725px';
    static readonly MAX_COLLABORATORS = 10;
    static readonly MAX_AVAILABLE_COLLABORATORS = 20;
    static readonly ESTIMATE_FORCE_PUBLISH_COST_REVIEW_REQUEST = "Estimate is force published on cost review request";
    static readonly ESTIMATE_ADD_ON_COST_REVIEW_REQEST = "Estimate checkout on cost review request";
    static readonly ESTIMATE_FORCE_PUBLISH_COST_REVIEW_CANCEL= "Estimate is force published on cost review cancel";
    static readonly ESTIMATE_ADD_ON_COST_REVIEW_CANCEL = "Estimate checkout on cost review cancel";
    static readonly ESTIMATE_FORCE_PUBLISH_COST_REVIEW_UNLOCK = "Estimate is force published on Unlock of approved cost review";
    static readonly ESTIMATE_ADD_ON_UNLOCK_COST_REVIEW = "Estimate checkout on Unlock of approved cost review";
    static readonly ESTIMATE_FORCE_PUBLISH_PRODUCT_PROMOTION = "Estimate is force published on product promotion request";
    static readonly ESTIMATE_ADD_ON_PRODUCT_PROMOTION = "Estimate checkout on product promotion request";
    static readonly ESTIMATE_FORCE_PUBLISH_WHILE_EXPORTING_PROPOSAL = "Estimate is force published on proposal generation";
    static readonly ESTIMATE_ADD_ON_PROPOSAL_EXPORT = "Estimate checkout on proposal generation";
    static readonly CRM_ESTIMATE_FORCE_PUBLISH_LINKING_OPPORTUNITY = "Estimate is force published on opportunity link";
    static readonly CRM_ESTIMATE_ADD_ON_OPPORTUNITY_LINK = "Estimate checkout on opportunity link is successful";
    static readonly CRM_ESTIMATE_FORCE_PUBLISH_UNLINKING_OPPORTUNITY = "Estimate is force published on opportunity unlink";
    static readonly CRM_ESTIMATE_ADD_ON_OPPORTUNITY_UNLINK = "Estimate checkout on opportunity unlink is successful";
    static readonly CRM_ESTIMATE_FORCE_PUBLISH_CREATE_OPPORTUNITY = "Estimate is force published on opportunity creation";
    static readonly ESTIMATE_FORCE_PUBLISH_WHILE_SAP_SUBMISSION = "Collaborative Estimate is Force published on SAP submittal";
    static readonly ESTIMATE_FORCE_PUBLISH_COST_REVIEWER_REMOVE = "Estimate is force published on cost reviewer's removal.  ({0} : {1})";
    static readonly ESTIMATE_ADD_ON_COST_REVIEW_REMOVE = "Estimate checkout on cost reviewer's removal ({0} : {1})";
    static readonly ESTIMATE_FORCE_PUBLISH_COST_REVIEWER_REPLACE = "Estimate is force published on cost reviewer's replacement. ({0} : {1} -> {2} : {3})";
    static readonly ESTIMATE_ADD_ON_COST_REVIEWER_REPLACE = "Estimate checkout on cost reviewer's replacement. ({0} : {1} -> {2} : {3})";
    static readonly ESTIMATE_FORCE_PUBLISH_SOL_WHILE_SAP_RESUBMISSION = "Estimate is force published on SAP Re-submission";
    static readonly ESTIMATE_ADD_SOL_ON_SAP_RESUBMISSION = "Estimate checkout on SAP Re-submission";
    static readonly COLLABORATORS_ADDED = "Collaborators are added";
    static readonly COLLABORATORS_REMOVED = "Collaborators are removed";
    static readonly COLLABORATORS_ACCESS_LEVEL_CHANGED = "Collaborators access level is changed";
    static readonly PRIMARY_USER_CHANGED = "Primary user is changed";

    static readonly MAX_COST_REVIEWERS = 5;

    static readonly BLANK_SPACE = " ";
    static readonly NON_BREAKING_SPACE = "&nbsp;";
    static readonly HTML_BREAK_LINE_TAG = "<br>";
    static readonly NEW_LINE_TEXT = "<NewLine>";
    static readonly COLLABORATION_OWNER_ROLE_ID = 0;
    static readonly HYPHEN = "-";

    static readonly ZERO = 0;
    static readonly ONE = 1;
    static readonly TWO = 2;
    static readonly THREE = 3;
    static readonly FOUR = 4;
    static readonly FIVE = 5;
    static readonly NA_LABOR_VALUE = -99999;
    static readonly EMPTY_STRING = '';
    static readonly ZERO_STRING = '0';
    static readonly SPLIT_FULL_WIDTH = 100;
    static readonly MAX_ESTIMATE_VALUE = 150000;
    static readonly SHIPPING_RATE_MAX_VALUE = 1000;
    static readonly SHIPPING_SELL_PRICE_MAX_VALUE = 999999999999;
    static readonly SELL_AS_MAX_VALUE = 999999999999999.99;
    static readonly PRODUCT_PROMOTION_DISCOUNT_DOLLARS_MAX = 999999999999.99;
    static readonly SUBSIDY_DOLLARS_MAX = 9999999.99;
    static readonly MATERIAL_RATE_INSTALL_TYPE_MAX = 999;
    static readonly ZERO_POINT_ZERO_ONE = 0.01;
    static readonly OVERTIME_RATES_MAX_VALUE = 9999.99;
    static readonly ESTIMATE_PROPERTIES_GM_PERCENT_MIN_VALUE = -999999999999999.99;
    static readonly ESTIMATE_PROPERTIES_GM_PERCENT_MAX_VALUE = 999999999999999.99;
    static readonly DEFAULT_GM_PERCENT = 30.00;
    static readonly DEFAULT_MARKUP_PERCENT = 42.86;


    static readonly NEGATIVE_ONE = -1;
    static readonly EMPTY = '';
    static readonly ELEVEN = 11;
    static readonly TWELVE = 12;
    static readonly SIXTEEN = 16;
    static readonly NINETEEN = 19;
    static readonly TWENTY_TWO = 22;
    static readonly TWENTY_THREE = 23;
    static readonly TWENTY_FOUR = 24;
    static readonly TWENTY_FIVE = 25;
    static readonly TWENTY_SIX = 26;
    static readonly TWENTY_SEVEN = 27;
    static readonly TWENTY_EIGHT = 28;
    static readonly THIRTY_ONE = 31;
    static readonly FORTY = 40;
    static readonly FORTY_ONE = 41;
    static readonly FORTY_EIGHT = 48;
    static readonly FORTY_NINE = 49;
    static readonly FIFTY = 50;
    static readonly FIFTY_ONE = 51;
    static readonly HUNDRED = 100;
    static readonly NINETY_NINE_POINT_NINE_NINE = 99.99;
    static readonly NINE_HUNDRED_NINETY_NINE_POINT_NINE_NINE = 999.99;
    static readonly NINETY_NINE = 99.00;
    static readonly DATE_FORMAT = 'MM/dd/yyyy';
    static readonly ESTIMATED_DATE = '12/31/9999';
    static readonly ZERO_PERCENT = '0%';
    static readonly TWO_THOUSAND_SEVEN = 2007;
    static readonly TYPE_ERROR = 'error';
    static readonly TYPE_SUCCESS = 'success';
    static readonly TYPE_WARNING = 'warning';
    static readonly TYPE_INFO = 'info';
    static readonly SUCCESS_TITLE = 'Success';
    static readonly ERROR_TITLE = 'Error';
    static readonly WARNING_TITLE = 'Warning';
    static readonly INFO_TITLE = 'Info';
    static readonly DEFAULT_DIALOG_WIDTH = '400px';
    static readonly OPEN_ESTIMATE_OUTDATED_LABOR_ERROR_CODE = '1905';
    static readonly OPEN_ESTIMATE_OUTDATED_LABOR_DIALOG_WIDTH = '550px';
    static readonly DEFAULT_NOT_APPLICABLE_STRING = 'N/A';
    static readonly NOT_APPLICABLE = 'NA';
    static readonly VERSION_WEB = 'Web';
    static readonly SEVEN = 7;

    //Product Promotion Constants
    static readonly AUTHORIZATION_CODE_MIN_LENGTH = 10;

    //Special Characters
    static readonly DOT = '.'
    static readonly DOLLAR_SIGN = '$';
    static readonly COMMA = ','
    static readonly HASH = '#'
    static readonly COLON = ':';
    static readonly PERCENT = '%';
    static readonly SPACE = ' ';

    //General COnfiguration Constants
    static readonly SALES_OFFICES_EXCLUDED_FROM_TRAVEL = 'SalesOfficesExcludedFromTravel';


    //Report Constants
    static readonly REPORT_PAGEORIENTATION_LANDSCAPE = 'landscape';
    static readonly REPORT_PAGEORIENTATION_PORTRAIT = 'portrait';
    static readonly UNKNOWN_COO = 'Unknown COO';
    static readonly TYPICAL_OF_LOGO = '∞';
    static readonly REPORT_ORANGE_COLOR = '#ffdfbf'
    static readonly REPORT_HIGHLIGHT_COLOR = "#FFCA96";
    static readonly REPORT_DARK_BLUE_COLOR = "#004080"
    static readonly REPORT_LIGHT_BLUE_COLOR = "#c6d9f1";
    static readonly REPORT_WHITE_COLOR = "#ffffff";
    static readonly CENTER_ALIGNMENT = "center";
    static readonly LEFT_ALIGNMENT = "left";
    static readonly RIGHT_ALIGNMENT = "right";
    static readonly YES_NO = 'YES_NO';
    static readonly YES_NO_NA = 'YES_NO_NA';
    static readonly INSTALL_TYPE = 'INSTALL_TYPE';
    static readonly SYSTEM_TYPE = 'SYSTEM_TYPE';
    static readonly ADDITIONAL_SYSTEMS = 'ADDITIONAL_SYSTEMS';
    static readonly DESIGO_PANELS = 'DESIGO_PANELS';
    static readonly BACKUP_AMPS = 'BACKUP_AMPS';
    static readonly BATTERY_BACKUP = 'BATTERY_BACKUP';
    static readonly CLASS_A_B = 'CLASS_A_B';
    static readonly CLASS_A_B_X = 'CLASS_A_B_X';
    static readonly COMMUNICATION_METHOD = 'COMMUNICATION_METHOD';
    static readonly NETWORK_STYLE = 'NETWORK_STYLE';
    static readonly NETWORK_OPTIONS = 'NETWORK_OPTIONS';
    static readonly SYSTEM_INTERFACES = 'SYSTEM_INTERFACES';
    static readonly FIRE_SMOKE_DAMPERS_PARAMETER = 'FIRE_SMOKE_DAMPERS_PARAMETER';
    static readonly LED_ANNUNCIATOR = 'LED_ANNUNCIATOR';
    static readonly ALPHA_NUMERIC_ANNUNCIATOR = 'ALPHA_NUMERIC_ANNUNCIATOR';
    static readonly SIEMENS_OTHER = 'SIEMENS_OTHER';
    static readonly UNDEFINED = 'Undefined';
    static readonly STRAIGHT_TIME_CASE = "Straight";
    static readonly STRAIGHT_TIME_CASE_FR = "Direct";
    static readonly OT_11X_TIME_CASE = "1.1X";
    static readonly PWR_11X_TIME_CASE = "PWR 1.1X";
    static readonly PWR_11X_TIME_CASE_FR = "TPE X 1.1";
    static readonly OT_15X_TIME_CASE = "1.5X";
    static readonly OT_2X_TIME_CASE = "2X";
    static readonly PWR_STRAIGHT_TIME_CASE = "PWR";
    static readonly PWR_STRAIGHT_TIME_CASE_FR = "TPE";
    static readonly PWR_15X_TIME_CASE = "PWR 1.5X";
    static readonly PWR_15X_TIME_CASE_FR = "TPE X 1.5";
    static readonly PWR_2X_TIME_CASE = "PWR 2X";
    static readonly PWR_2X_TIME_CASE_FR = "TPE X 2";
    static readonly MASS_NOTIFICATION = 'Mass Notification';
    static readonly VESDA_MATERIAL = 'VESDA Material';
    static readonly SIEMENS_MATERIAL = 'Siemens Material';
    static readonly SIOEM_MATERIAL = 'SI OEM Material';
    static readonly SIEMENS_MATERIAL_FR = 'Mat\u00e9riel Siemens';
    static readonly SIOEM_MATERIAL_FR = 'Mat\u00e9riel SI OEM';
    // Material items store a localized materialType, so EN and FR labels must both be recognized.
    static readonly SIEMENS_MATERIAL_TYPES: ReadonlySet<string> = new Set([CONSTANTS.SIEMENS_MATERIAL, CONSTANTS.SIEMENS_MATERIAL_FR]);
    static readonly PRODUCT_PROMOTION_MATERIAL_TYPES: ReadonlySet<string> = new Set([
        CONSTANTS.SIEMENS_MATERIAL, CONSTANTS.SIEMENS_MATERIAL_FR,
        CONSTANTS.SIOEM_MATERIAL, CONSTANTS.SIOEM_MATERIAL_FR
    ]);
    static readonly IVK_B = 'B';
    // Materials with no product promotion type carry a NUL character rather than an empty string.
    static readonly EMPTY_PP_TYPE = '\u0000';
    static readonly SIEMENS_THIRD_PARTY = 'SIEMENS_THIRD_PARTY';
    static readonly SIEMENS_THIRDPARTY_CUSTOMER = 'SIEMENS_THIRDPARTY_CUSTOMER';
    static readonly SIPASS_MATERIAL = 'SiPass Material';
    static readonly COST_OVERRIDES = 'Cost Overrides';
    static readonly SPECIAL_EQUIPMENT = 'SPECIAL_EQUIPMENT';
    static readonly USER_DEFINED = 'User Defined';
    static readonly PREVAILING_WAGE = 'Prevailing Wage';
    static readonly OVERTIME = 'Overtime';
    static readonly MASS_NOTIFICATION_DEVICES = 'Mass Notification Devices';
    static readonly YES_NO_UNKNOWN = 'YES_NO_UNKNOWN';


    //Project Category Constants
    static readonly PROJECT_CATEGORY_W = 'W';
    static readonly PROJECT_CATEGORY_T = 'T';
    static readonly PROJECT_CATEGORY_S = 'S';


    //Nodetype Constants
    static readonly SIEMENS_CUSTOMER = 'SIEMENS_CUSTOMER';
    static readonly DOOR_HARDWARE_TYPE = 'DOOR_HARDWARE_TYPE';
    static readonly SIEMENS_SUBCONTRACTOR_OTHER = 'SIEMENS_SUBCONTRACTOR_OTHER';
    static readonly INTEGRATION_REQUIRED = 'INTEGRATION_REQUIRED';
    static readonly CONDUIT_TYPE = 'CONDUIT_TYPE';
    //Nodetype Constants
    static readonly NODETYPE_AREA = 'Area';
    static readonly NODETYPE_BSETSYSTEM = 'BSETSystem';
    static readonly NODETYPE_SUBSYSTEM = 'SubSystem';
    static readonly NODETYPE_CONTROLLER = 'Controller';
    static readonly NODETYPE_DESIGOOPTIC = 'Desigo Optic';
    static readonly NODETYPE_PANEL = 'Panel';
    static readonly NODETYPE_PROJECT = 'Project';
    static readonly NODETYPE_MATERIAL = 'Material';

    //Section Indicators
    static readonly SSN_INDICATOR = 'SSN';

    //Cost Review Constants
    static readonly COST_REVIEW_APPROVAL_CHANGE_PERCENT = 10;
    static readonly COST_REVIEW_LABOR_TDC_PERCENT_THRESHOLD_US = 'Cost_Review_Labor_TDC_Percent_Threshold_US';
    static readonly COST_REVIEW_LABOR_TDC_PERCENT_THRESHOLD_CA = 'Cost_Review_Labor_TDC_Percent_Threshold_CA';
    static readonly MIN_ENGINEER_PERCENT_FOR_AUTOMATION = 'MinEngineerPercentForAutomation';
    static readonly MIN_ENGINEER_PERCENT_FOR_AUTOMATION_CA = 'MinEngineerPercentForAutomationCA';
    // Graphics standard verification (GIS) visibility: aggregated graphics labor hours must exceed this threshold.
    static readonly GRAPHICS_HOURS_VISIBILITY_THRESHOLD = 8;
    // Reference numbers of the graphics tasks that contribute to the GIS visibility threshold.
    static readonly WORKSTATION_GRAPHICS_FLOOR_PLANS_TASK_ID = 'T156';
    static readonly DASHBOARD_GRAPHICS_TASK_ID = 'T302';
    static readonly GRAPHICS_PREWORK_CLOSEOUT_TASK_ID = 'T467';
    // General-config key holding the comma-separated sales offices that require an Energy OM cost review.
    static readonly ALLOWED_ENERGY_SALES_OFFICES_FOR_COST_REVIEW_REQUIRED = 'Allowed_Energy_SalesOffices_For_Cost_Review_Required';
    // General-config key holding the comma-separated part SSNs that require an Energy OM cost review.
    static readonly ALLOWED_ENERGY_PARTS_FOR_COST_REVIEW_REQUIRED = 'Allowed_Energy_Parts_For_Cost_Review_Required';
    // General-config keys gating whether prefab controllers are available (culture specific).
    static readonly IS_PREFAB_AVAILABLE = 'IsPrefabAvailable';
    static readonly IS_PREFAB_AVAILABLE_CA = 'IsPrefabAvailable_CA';
    // Reference numbers identifying Connected Digital Package (CDP) parts.
    static readonly CXG3_X300_KIT = 'CXG3.X300.KIT';
    static readonly CXG3_X300_CONNECT_X300 = 'S55842-Z121-A100';
    static readonly CXG3_X200_CONNECT_X200 = 'S55842-Z131-A100';
    static readonly CFG3_F200_DESIGO_OPTIC = 'CFG3.F200';
    static readonly MIXED = 'Mixed';
    static readonly SUMMARY_LABEL = 'Summary';
    static readonly NORMAL_HOURS_RATE = 'Normal Hours Rate';
    static readonly AUTO_RISK_LABEL = 'Auto Risk';
    static readonly TECHNOLOGY_FEE_LABEL = 'Technology Fee';
    static readonly PLANNED_COST_ITEM_NAMES = {
        risk: 'Risk',
        material: 'Material',
        subcontractor: 'Subcontractor',
        miscellaneous: 'Miscellaneous',
        shippingAndHandling: 'Shipping & Handling',
        warranty: 'Warranty',
        other: 'Other',
    } as const;
    static readonly MULTIPLE_REVIEWERS = 'Multiple Reviewers';
    static readonly NEGATIVE_ONE_STRING = '-1';
    static readonly SENTINEL_LABOR_VALUES: ReadonlyArray<number> = [-999999999, -9999999, -99999];
    static readonly AUTOMATION_SERVICE_PROJECT_US = 3;
    static readonly MECHANICAL_SERVICE_PROJECT_US = 8;
    //for en_can
    static readonly AUTOMATION_SERVICE_PROJECT_CN_EN = 11;
    static readonly AUTOMATION_SERVICE_PROJECT_CN_FR = 19;
    //for fn_can
    static readonly MECHANICAL_SERVICE_PROJECT_CN_EN = 16;
    static readonly MECHANICAL_SERVICE_PROJECT_CN_FR = 24;

    //Travel Constants
    static readonly NUMBER_OF_WORKING_HOURS_A_DAY = 7;

    //Risk Items
    static readonly RISK_ITEMS = ['M0007', 'M0023', 'M0024'];

    //Non-Taxable Items
    static readonly NON_TAXABLE_ITEMS = ['M8888'];

    //User defined subcontractors (no catalog guid) are grouped under one row
    static readonly USER_DEFINED_SUBCONTRACTOR_PREFIX = 'US';
    static readonly USER_DEFINED_SUBCONTRACTOR_REFERENCE = 'S9999';
    static readonly USER_DEFINED_SUBCONTRACTOR_DESCRIPTION = 'User Defined Subcontractor';

    //Overtime PWR Constants
    static readonly OT = 0
    static readonly OT_11X = 1
    static readonly OT_15X = 2
    static readonly OT_2X = 3
    static readonly PWR = 4
    static readonly PWR_11X = 5
    static readonly PWR_15X = 6
    static readonly PWR_2X = 7

    // Escalation Calculation Constants
    static readonly ZERO_POINT_ZERO: number = 0.00;
    static readonly ZERO_POINT_FIVE: number = 0.50;
    static readonly ZERO_POINT_SIX: number = 0.60;
    static readonly ONE_POINT_ZERO: number = 1.00;
    static readonly TWO_POINT_ZERO: number = 2.00;
    static readonly TWO_POINT_FIVE: number = 2.50;
    static readonly SIX_POINT_ZERO: number = 6.00;
    static readonly SEVEN_POINT_FIVE: number = 7.50;
    static readonly THIRTY_POINT_ZERO: number = 30.00;
    static readonly EIGHTY_FIVE_POINT_ZERO: number = 85.00;
    static readonly HUNDRED_POINT_ZERO: number = 100.00;
    static readonly MATERIAL = 'Material';
    static readonly LABOR = 'Labor';
    /** Financial year runs Oct 1 → Sep 30 (month index 9). */
    static readonly FISCAL_YEAR_START_MONTH = 9;

    static readonly YES = 'Yes';
    static readonly NO = 'No';
    static readonly CANCEL = 'Cancel';
    static readonly NA = 'N/A';
    static readonly Y = 'Y';
    static readonly N = 'N';
    static readonly USER_DEFINED_REFERENCE_NUMBER = 'R9999';
    static readonly NEGATIVE_NA_VALUE = -9999999;

    static readonly CANVAS_WIDTH = 200;
    static readonly CANVAS_HEIGHT = 200;
    static readonly SYSTEMS = 'SYSTEMS';
    static readonly SYSTEM_NOTES = 'SYSTEM_NOTES';
    static readonly INTERNAL_SYSTEM_NOTES = 'Internal System Notes';
    static readonly EXTERNAL_SYSTEM_NOTES = 'External System Notes'

    static readonly THREE_HUNDRED = 300;
    static readonly BUSINESS_FIRE = 'F';
    static readonly BUSINESS_SECURITY = 'S';
    static readonly BUSINESS_AUTOMATION = 'A';
    static readonly BUSINESS_ELECTRICAL = 'E';
    static readonly BUSINESS_MECHANICAL = 'M';
    static readonly DEFAULT_ESTIMATE_ID = "00000000-0000-0000-0000-000000000000";

    static readonly UPN_INDICATOR = 'UPN';
    static readonly RPN_INDICATOR = 'RPN';
    static readonly APN_INDICATOR = 'APN';
    static readonly SIPART_INDICATOR = 'SiParts';
    static readonly DASHBOARD_SPINNER = 'dashboardSpinner';

    // Federal Funded Constants
    static readonly DISABLED = 'DISABLED';
    static readonly GREYED_OUT = 'Greyed out';
    static readonly CMMC_LEVEL_CUI = 'Level 2 - CUI';
    static readonly CMMC_LEVEL_FCI = 'Level 1 - FCI';
    static readonly SOLD_TO = 'Sold To';
    static readonly SHIP_TO = 'Ship To';
    static readonly BILL_TO = 'Bill To';
    static readonly END_USER = 'End-Account';
    static readonly ACCOUNT_NAME_KEY = 'accountName';
    static readonly SHIP_TO_KEY = 'shipToLocation';
    static readonly BILL_TO_KEY = 'billTO';
    static readonly END_USER_KEY = 'endUser';
    static readonly ESTIMATE = 'estimate';
    static readonly BASE_OPPORTUNITY = 'baseOpportunity'

    // CRM Dialog Constants
    static readonly DIALOG_WIDTH_LARGE = '90vw';
    static readonly DIALOG_HEIGHT_LARGE = '75vh';
    static readonly DIALOG_WIDTH_MEDIUM = '700px';
    static readonly DEFAULT_CULTURE_ID = 1;

    // Opportunity Type Constants
    static readonly OPPORTUNITY_TYPE_BASE_ORDER = 'baseOrder';
    static readonly OPPORTUNITY_TYPE_CHANGE_ORDER = 'changeOrder';

    // Opportunity Form Defaults
    static readonly DEFAULT_RESTRICTION_TYPE = 'unrestricted';
    static readonly RESTRICTED_TYPE = 'restricted';
    static readonly RESTRICTED_INDICATOR = 'Y';

    // Material category type constants (used in shipping/warranty/cost calculations)
    // @deprecated Use MaterialSubCategory enum instead
    static readonly MATERIAL_CATEGORY_SIEMENS = 'siemens';
    static readonly MATERIAL_CATEGORY_OUTSIDE = 'outside';
    static readonly MATERIAL_CATEGORY_MECHANICAL = 'mechanical';
    static readonly MATERIAL_CATEGORY_ELECTRICAL = 'electrical';

    // Material label Constants (display names used in shipping/warranty dialogs)
    static readonly OUTSIDE_MATERIAL = 'Outside Material';
    static readonly MECHANICAL_MATERIAL = 'Mechanical Material';
    static readonly ELECTRICAL_MATERIAL = 'Electrical Material';

    // Shipping & Handling Constants
    static readonly SHIPPING_DIALOG_WIDTH = '600px';

    // Escalation Constants
    static readonly ESCALATION_DIALOG_WIDTH = '700px'

    // Warranty Constants
    static readonly CALCULATIONS_PRECISION = 6;
    static readonly PPM_DISCOUNT_TYPE_DISCOUNT = 1;
    static readonly WARRANTY_PERIOD_SIEMENS = 'SIEMENS_MATERIAL';
    static readonly WARRANTY_PERIOD_OUTSIDE = 'OUTSIDE_MATERIAL';
    static readonly WARRANTY_PERIOD_MECHANICAL = 'MECHANICAL_MATERIAL';
    static readonly WARRANTY_PERIOD_ELECTRICAL = 'ELECTRICAL_MATERIAL';
    static readonly WARRANTY_DIALOG_WIDTH = '800px';

    // Warranty FormGroup name Constants
    static readonly WARRANTY_FORM_GROUP_SIEMENS = 'siemensMaterialGroup';
    static readonly WARRANTY_FORM_GROUP_OUTSIDE = 'outsideMaterialGroup';
    static readonly WARRANTY_FORM_GROUP_MECHANICAL = 'mechanicalMaterialGroup';
    static readonly WARRANTY_FORM_GROUP_ELECTRICAL = 'electricalMaterialGroup';

    // Warranty rate control name Constants
    static readonly WARRANTY_RATE_YEAR1 = 'year1Rate';
    static readonly WARRANTY_RATE_YEAR2 = 'year2Rate';
    static readonly WARRANTY_RATE_YEAR3 = 'year3Rate';
    static readonly WARRANTY_RATE_YEAR4 = 'year4Rate';
    static readonly WARRANTY_RATE_YEAR5 = 'year5Rate';
    static readonly WARRANTY_RATE_TOTAL = 'total';
    static readonly YEAR_HEADER_DEFAULT_PREFIX = 'Year ';

    // CRM Popup Constants
    static readonly ID = 'ID';
    static readonly NAME = 'Name';
    static readonly DESCRIPTION = 'Description';
    static readonly STATUS = 'Status';
    static readonly TYPE = 'Type'
    static readonly CUSTOMER = 'Customer';
    static readonly AUTHOR = 'Author';
    static readonly OWNER = 'Owner';
    static readonly MODIFIED_BY = 'Modified By';
    static readonly USER_TYPE = 'User Type';
    static readonly SEGMENT = 'Segment';
    static readonly SEGMENT_LOWERCASE = 'segment';
    static readonly SALES_OFFICE = 'Sales Office';
    static readonly CREATION_DATE = 'Creation Date';
    static readonly START_DATE = 'Start Date';
    static readonly END_DATE = 'End Date';
    static readonly MODIFICATION_DATE = 'Modification Date';
    static readonly LAST_UPLOAD_DATE = 'Last Upload Date';
    static readonly SAP_SUBMISSION_DATE = 'SAP Submission Date';
    static readonly GM_PERCENT = 'GM%';
    static readonly TOTAL_SELL_PRICE = 'Total Sell Price';

    static readonly BUSINESS_HIERARCHY = 'Business Hierarchy';
    static readonly SELL_AS = 'Sell As (Sales $)';
    static readonly EXPECTED_BOOK = 'Expected Book';

    static readonly SALESFORCE_ID = 'Salesforce ID';
    static readonly SAP_NUMBER = 'SAP Number';
    static readonly ADDRESS1 = 'Address 1';
    static readonly ADDRESS2 = 'Address 2';
    static readonly CITY = 'City';
    static readonly STATE = 'State';
    static readonly ZIP_CODE = 'Zip Code';

    static readonly OPEN_ESTIMATE_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss.SSS';
    static readonly OPEN_ESTIMATE_START_END_DEFAULT_DATE = new Date(9999, 11, 31, 23, 59, 59, 997);

    static readonly COSTREVIEW = 'CostReview';
    static readonly SUBMITTAL = 'Submittal';
    static readonly FILE_EXT_PDF = '.pdf';
    static readonly UNDERSCORE = '_';
    static readonly DATASTREAM_PREFIX = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,';


    static readonly GOC_ZONE_ID = 24;

    // Properties Dialog Constants
    static readonly HEADER = 'header';
    static readonly CATEGORY = 'category';
    static readonly DECISION_TOOL_LINK = 'https://taxabilitydecisiontool.gbsus.siemens.cloud/';

    // Error Codes
    static readonly ERROR_FOUR_ZERO_ONE = 401;
    static readonly ERROR_FOUR_ZERO_FOUR = 404;
    static readonly ERROR_FOUR_ZERO_SIX = 406;
    static readonly ERROR_FOUR_ZERO_SEVEN = 407;
    static readonly ERROR_FOUR_TWO_TWO = 422;
    static readonly PROPOSAL_INVALID_PGT_ACCOUNTS_ERROR = 1305;
    static readonly PROPOSAL_PUBLISHED_UPDATE_ERROR = 1306;

    // Maximum numeric value for job details form fields
    static readonly MAX_JOB_DETAILS_NUMERIC_VALUE = 999999999;
    static readonly NONE = 'None';
}
